module.exports = {
  siteTitle: "minle", // <title>
  shortSiteTitle: "minle", // <title> ending for posts and pages
  siteDescription: "minle",
  siteUrl: "https://www.minle.de",
  // pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",

  /* author */
  authorName: "minle",
  authorTwitterAccount: "",
  authorGithub: "https://github.com/robinson",
  authorStackoverflow: "",
  authorLinkedin: "",
  authorCodeforces: "",
  authorYoutube: "",
  authorUnsplash: "",
  authorYCombinator: "",

  /* header text */
  headerTitle: "minle",
  headerSubTitle: "le lang thang",

  /* manifest.json */
  manifestName: "minle",
  manifestShortName: "minle", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "white",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",
};
